// ** React Imports
import { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';

// ** Redux Imports
import { Provider } from 'react-redux';
import { store } from './redux/storeConfig/store';

// ** Toast & ThemeColors Context
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeContext } from './utility/context/ThemeColors';

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner';

// ** Ripple Button
import './@core/components/ripple-button';

// ** PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-jsx.min';

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css';

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss';

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css';
import './@core/scss/core.scss';
import './assets/scss/style.scss';

// ** Service Worker
import * as serviceWorker from './serviceWorker';
import { AddPetProviderWrapper } from './utility/context/AddPetContext';
import { ChatProviderWrapper } from './utility/context/ChatContext';

// ** Reload on stale chunk after new deployment
window.addEventListener('unhandledrejection', (event) => {
  if (event?.reason?.name === 'ChunkLoadError') {
    window.location.reload();
  }
});

// ** Lazy load app
const LazyApp = lazy(() => import('./App'));

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <Suspense fallback={<Spinner >{""}</Spinner>}>
      {/* <AbilityContext.Provider value={ability}> */}
      <ThemeContext>
        <ChatProviderWrapper>
          <AddPetProviderWrapper>
            <LazyApp />
            <ToastContainer newestOnTop />
          </AddPetProviderWrapper>
        </ChatProviderWrapper>
      </ThemeContext>
      {/* </AbilityContext.Provider> */}
    </Suspense>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

